import { BrickInventoryEntry } from "../../../../BrickInventory/BrickInventory";
import { SetEntry } from "../../../../SetInventory/SetInventory";
import { ActionChange } from "../../../ActionInfo/ActionInfo";

export const meetsCostRequirementsSingleBrickPack = (
  cost: ActionChange,
  newBricks: Map<string, BrickInventoryEntry>,
  newSets: Map<string, SetEntry>,
  totalAmt: number, // total packs to purchase
) => {
  // Validate if costs for action can be met (both bricks and sets)
  const trueCost = cost.baseChangeValue * totalAmt;

  // Default to "brick" if type not specified (backward compatibility)
  const costType = cost.type || "brick";

  if (costType === "brick") {
    // Check brick costs
    const currBrick = newBricks.get(cost.brickId);

    return !(
      !currBrick ||
      Number.isNaN(currBrick.amount) ||
      currBrick.amount < trueCost
    );
  } else if (costType === "set") {
    // Check set costs
    const currSet = newSets.get(cost.brickId); // brickId field contains set ID

    return !(!currSet || currSet.count < trueCost);
  }

  return false;
};
